// HUD rate smoothing (lead decision L12): the secondary "auto $X/s" line shows the sim's young-window
// automated $/s (`incomeView.autoYoungPerSec`) through an exponential moving average with time constant
// `ui.json hud.autoSmoothSec`, so one lumpy payout does not make the number jump. UI-side only: the sim state
// never holds a smoothed value. The first sample (and any sample after `reset`) is shown as is.

export interface RateSmoother {
  /** Feeds the current value at wall time `nowMs`; returns the smoothed value. */
  update(target: number, nowMs: number): number;
  value(): number | null;
  reset(): void;
}

export function createRateSmoother(tauSec: number): RateSmoother {
  if (!(tauSec > 0)) throw new RangeError('tauSec must be > 0');
  let v: number | null = null;
  let t = 0;
  return {
    update(target, nowMs) {
      if (v === null) {
        v = target;
        t = nowMs;
        return v;
      }
      const dt = (nowMs - t) / 1000;
      t = nowMs;
      if (dt > 0) v += (target - v) * (1 - Math.exp(-dt / tauSec));
      return v;
    },
    value: () => v,
    reset() {
      v = null;
    },
  };
}
